import React from 'react';

const NoItems = ({ message = 'No items found' }) => {
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				marginBottom: '32px',
				color: '#6c757d',
				height: '-webkit-fill-available',
				width: '100%',
			}}>
			<div style={{ marginBottom: 24 }}>
				<img
					src={process.env.PUBLIC_URL + '/image/empty-box.png'}
					alt='No items'
					style={{ width: 80, height: 80, opacity: 0.7 }}
				/>
			</div>
			<div style={{ fontSize: 22, fontWeight: 600, marginBottom: 8 }}>{message}</div>
		</div>
	);
};

export default NoItems;
